import { CreateResource, createApiResource } from '../apiResourceFactory';
import { API } from '../apiService';

import type { StCapacityPhoneCallCreateDTO, PhoneCallDetailDTO } from '../apiTypes.shim';

interface ServiceTitanCapacityPhoneCallResource
  extends CreateResource<StCapacityPhoneCallCreateDTO, PhoneCallDetailDTO> {}

export const createServiceTitanCapacityPhoneCallResource = (): ServiceTitanCapacityPhoneCallResource => {
  const phoneCallUri = `v2/phone-calls/st-capacity`;
  const { create, useCreate } = createApiResource(API, phoneCallUri);
  return { create, useCreate };
};
